module.exports = __webpack_public_path__ + "static/img/c7x2.2be73037.png";